module.exports = __webpack_public_path__ + "img/Icon_disciplina.87d95e12.svg";